import { css } from '@emotion/react';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { Box, IconButton } from '@mui/material';
import { FC } from 'react';
import { MessageFeedback } from '../../../schemas/agent-conversation.schema';

const feedbackContainerStyles = css`
  display: flex;
  margin-top: 8px;
`;

const feedbackButtonStyles = css`
  padding: 4px;

  &:hover {
    background-color: transparent;
  }

  .MuiSvgIcon-root {
    font-size: 1.1rem;
    transition: color 150ms ease-in-out;
  }
`;

export interface FeedbackProps {
  messageId: number;
  feedback: MessageFeedback;
  onFeedback: (messageId: number, feedback: MessageFeedback) => void;
  disabled?: boolean;
}

export const FeedbackButtons: FC<FeedbackProps> = ({ messageId, feedback, onFeedback, disabled = false }) => {
  const isThumbUp = feedback === 'up';
  const isThumbDown = feedback === 'down';

  const handleThumbUp = () => {
    // Toggle: if already up, set to null; otherwise set to up
    onFeedback(messageId, isThumbUp ? null : 'up');
  };

  const handleThumbDown = () => {
    // Toggle: if already down, set to null; otherwise set to down
    onFeedback(messageId, isThumbDown ? null : 'down');
  };

  return (
    <Box css={feedbackContainerStyles}>
      <IconButton
        css={feedbackButtonStyles}
        onClick={handleThumbUp}
        disabled={disabled}
        aria-label={isThumbUp ? 'Remove positive feedback' : 'Mark as helpful'}
        aria-pressed={isThumbUp}
        size='small'
      >
        {isThumbUp ? <ThumbUpAltIcon color='secondary' /> : <ThumbUpOffAltIcon color='action' />}
      </IconButton>
      <IconButton
        css={feedbackButtonStyles}
        onClick={handleThumbDown}
        disabled={disabled}
        aria-label={isThumbDown ? 'Remove negative feedback' : 'Mark as not helpful'}
        aria-pressed={isThumbDown}
        size='small'
      >
        {isThumbDown ? <ThumbDownAltIcon color='secondary' /> : <ThumbDownOffAltIcon color='action' />}
      </IconButton>
    </Box>
  );
};
